"use client"

import type React from "react"

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";

import type { DocumentState } from "../types"
import MarkdownEditor from "./MarkdownEditor"

interface LeftPanelProps {
  documentState: DocumentState
  onDocumentChange: (state: Partial<DocumentState>) => void
}

const LeftPanel: React.FC<LeftPanelProps> = ({ documentState, onDocumentChange }) => {
  return (
    <Paper sx={{ height: "100dvh", flexDirection: "column" }}>
      <Box sx={{ height: "100dvh", flex: 1, overflow: "hidden" }}>
        <MarkdownEditor
          key={documentState.attachmentId}
          content={documentState.content}
          initialContent={documentState.content}
          filePath={documentState.fileName ? `https://ari-contents-f5f6avf7f8fga3ef.a01.azurefd.net/content/${documentState.fileName}` : undefined}
          onChange={(value) => onDocumentChange({ content: value })}
        />
      </Box>
    </Paper>
  )
}

export default LeftPanel